// extracted by mini-css-extract-plugin
module.exports = {"desktopBlock":"NCUz8McWjuc5UN-J","linkSection":"_3j0hAH19-Lm1roT7"};